// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datetime-picker {
  display: block;
}

.react-datetime-picker__wrapper {
  background: white;
  border: 1px solid #ced4da;
  border-radius: 4px;
  height: 46px;
}

.react-calendar button {
  color: black;
}

.react-datetime-picker__inputGroup {
  font-size: 1rem;
  text-align: center;
}

button.react-calendar__month-view__days__day--weekend {
  color: red;
}

button.react-calendar__tile--active {
  background: green;
  color: white;
}

.react-datetime-picker__calendar-button:hover, .react-datetime-picker__clear-button:hover {
  background: none;
}

.react-calendar__navigation button {
  cursor: pointer;
}

.react-datetime-picker__inputGroup__input {
  height: auto;
  margin-top: 0.7rem;
}`, "",{"version":3,"sources":["webpack://./src/components/DateTimePicker/datepicker-overrides.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".react-datetime-picker {\n  display: block;\n}\n\n.react-datetime-picker__wrapper {\n  background: white;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  height: 46px;\n}\n\n.react-calendar button {\n  color: black;\n}\n\n.react-datetime-picker__inputGroup {\n  font-size: 1rem;\n  text-align: center;\n}\n\nbutton.react-calendar__month-view__days__day--weekend {\n  color: red;\n}\n\nbutton.react-calendar__tile--active {\n  background: green;\n  color: white;\n}\n\n.react-datetime-picker__calendar-button:hover, .react-datetime-picker__clear-button:hover {\n  background: none;\n}\n\n.react-calendar__navigation button {\n  cursor: pointer;\n}\n\n.react-datetime-picker__inputGroup__input {\n  height: auto;\n  margin-top: 0.7rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
